const DatePickerConstants = {
  DAY: { name: 'dayPicker', value: 'DAY', label: 'DAY' },
  WEEK: { name: 'weekPicker', value: 'WEEK', label: 'WEEK' },
  MONTH: { name: 'monthPicker', value: 'MONTH', label: 'MONTH' },
};

export default DatePickerConstants;

